import React from 'react';
import firstStepConstants from '../common/Constants';
import { Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import AddressAutocomplete from '../common/AddressAutocomplete.js';
// import DeParamMovingURL from '../common/DeParamMovingURL.js';
import calculateAndStoreDistance from '../common/CalculateDistance.js';


class FirstStep extends React.Component {
    constructor(props) {
        super(props);

        // Setup save/read top component state
        this.saveTopState = props.saveTopState;
        this.readTopState = props.readTopState;

        // Get input variables from top state
        let savedStateFromTop = this.readTopState('firstStepState');

        //Setting up state variables from tor empty, with variable type
        this.state = {
            movingFromAddress: savedStateFromTop['movingFromAddress'] || {},
            movingToAddress: savedStateFromTop['movingToAddress'] || {},
            movingFromFlights: savedStateFromTop['movingFromFlights'] || {},
            movingFromElevator: savedStateFromTop['movingFromElevator'] || {},
            movingToFlights: savedStateFromTop['movingToFlights'] || {},
            movingToElevator: savedStateFromTop['movingToElevator'] || {},
            movingDate: savedStateFromTop['movingDate'] || null,
            pickupToDelivery: savedStateFromTop['pickupToDelivery'] ? savedStateFromTop['pickupToDelivery'] : 0,
            baseToPickup: savedStateFromTop['baseToPickup'] ? savedStateFromTop['baseToPickup'] : 0,
            deliveryState: savedStateFromTop['deliveryState'] ? savedStateFromTop['deliveryState'] : 0,
            pickupState: savedStateFromTop['pickupState'] ? savedStateFromTop['pickupState'] : 0,
            baseToDelivery: savedStateFromTop['baseToDelivery'] ? savedStateFromTop['baseToDelivery'] : 0,
            longestDistance: savedStateFromTop['longestDistance'] ? savedStateFromTop['longestDistance'] : 0,
            travelDuration: savedStateFromTop['travelDuration'] ? savedStateFromTop['travelDuration'] : 0,
            travelDurationBP: savedStateFromTop['travelDurationBP'] ? savedStateFromTop['travelDurationBP'] : 0,
            travelDurationDB: savedStateFromTop['travelDurationDB'] ? savedStateFromTop['travelDurationDB'] : 0,
            travelDurationPD: savedStateFromTop['travelDurationPD'] ? savedStateFromTop['travelDurationPD'] : 0,
            errorclass: 'before-error-validation',
        };

        //Binding functions
        this.onInputFieldChange = this.onInputFieldChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.calculateAndStoreDistance = calculateAndStoreDistance.bind(this);
        this.calculateDistances = this.calculateDistances.bind(this);
    }


    /**
     * Validation and saving of input fields
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    onInputFieldChange(event) {
        let { name, type } = event.target;
        let isFieldValid = false;

        // Text input
        if (type === 'text') {
            let oldAddressState = this.state[name];
            oldAddressState['isValid'] = false;
            this.setState(oldAddressState);
            isFieldValid = false;
        }

        // Dropdown input
        else {
            let { name, value } = event.target;
            this.setState({
                [name]: { 'value': event.target.options[event.target.selectedIndex].value, 'label': event.target.options[event.target.selectedIndex].text }
            });

            isFieldValid = value ? true : false;
        }
        event.target.className = (isFieldValid ? 'input-valid' : 'input-error');
    }


    /**
     * Validation and saving of Date field
     * @param  {[type]} date [description]
     * @return {[type]}      [description]
     */
    onDateChange(date) {
        this.state.movingDate = date;
        this.setState({
            movingDate: date.format('YYYY-MM-DD')
        });
        date.className = ('input-valid');
    }



    calculateDistances() {

        // If both addreses are defined calculate distances
        if (this.state.movingFromAddress.value && this.state.movingToAddress.value) {

            //Define location parameters for distance calculation
            //Four bases they use
            let baseFW = firstStepConstants.baseLocationFW;
            let baseA = firstStepConstants.baseLocationA;
            let baseDA = firstStepConstants.baseLocationDA;
            let baseH = firstStepConstants.baseLocationH;

            let pickup = this.state.movingFromAddress.value;
            let delivery = this.state.movingToAddress.value;
            let pickupState = this.state.movingFromAddress.cityAndState.state;
            let deliveryState = this.state.movingToAddress.cityAndState.state;

            let thebase = 0;
            let getobject = {};
            let baseTime = 0;
            // We need this function because just passing setState to the calculate function is not working dunno why
            const firstStepSetState = (newFirstStepState, callback) => {
                this.setState(newFirstStepState, callback);
            }

            //get closest Base
            let pickupBaseDistances = [];
            const thisfirst = () =>{
              this.calculateAndStoreDistance(baseFW, pickup, firstStepSetState, 'baseFWToPickup', () => calculateClosestBase('baseFWToPickup', baseFW));
              this.calculateAndStoreDistance(baseA, pickup, firstStepSetState, 'baseAToPickup', () => calculateClosestBase('baseAToPickup', baseA));
              this.calculateAndStoreDistance(baseDA, pickup, firstStepSetState, 'baseDAToPickup', () => calculateClosestBase('baseDAToPickup', baseDA));
              this.calculateAndStoreDistance(baseH, pickup, firstStepSetState, 'baseHToPickup', () => calculateClosestBase('baseHToPickup', baseH), );

            }

            //call this only when closest base is found
            const thenthis = (obj) => {
              this.calculateAndStoreDistance(getobject.base, pickup, firstStepSetState, 'baseToPickup', () => calculationCallback('baseToPickup'));
              this.calculateAndStoreDistance(getobject.base, delivery, firstStepSetState, 'baseToDelivery', () => calculationCallback('baseToDelivery'));
              this.calculateAndStoreDistance(pickup, delivery, firstStepSetState, 'pickupToDelivery', () => calculationCallback('pickupToDelivery'));
            }


            thisfirst();

            const calculateClosestBase = (staPrintovati, basename) => {

                console.log(staPrintovati + 'UPPER ' + this.state[staPrintovati].distance + 'TIME' + this.state[staPrintovati].timeEstimate);

                pickupBaseDistances.push({ baseDistance: this.state[staPrintovati].distance, baseTime: this.state[staPrintovati].timeEstimate, base: basename, name: staPrintovati });

                thebase = pickupBaseDistances.reduce((accumulator, currentValue) => currentValue.baseDistance < accumulator ? currentValue.baseDistance : accumulator, pickupBaseDistances[0].baseDistance);
                getobject = pickupBaseDistances.find(pickupBaseDistance => pickupBaseDistance.baseDistance === thebase);

                //Only call basetodelivery when basetopickup for all 4 locations have been calculated (when the closest base has been found)
                if(pickupBaseDistances.length>3){
                  thenthis(getobject);
                }

            }

           
    
            // After calculating distance with asinch matrix service calling Callback function to save states and calc most far away distance
            const calculationCallback = (staPrintovati) => {

                console.log('theobject', getobject, " thebase", thebase,"this.state.baseToDelivery.timeEstimate", this.state.baseToDelivery.timeEstimate);

                console.log(staPrintovati + 'LOWER ' + this.state[staPrintovati].distance + 'TIME' + this.state[staPrintovati].timeEstimate);

                // Calculate Travel time Base to Pickup + Base to Delivery
                let travelDuration = 0;
                travelDuration = getobject.baseTime + this.state.baseToDelivery.timeEstimate;

                console.log('tetetravelDuration',travelDuration );

                let longestDistance = 0;
                if (this.state.baseToDelivery.distance >= getobject.baseDistance && this.state.baseToDelivery.distance >= this.state.pickupToDelivery.distance) {
                    longestDistance = this.state.baseToDelivery.distance;
                } else if (getobject.baseDistance >= this.state.baseToDelivery.distance && getobject.baseDistance >= this.state.pickupToDelivery.distance) {
                    longestDistance = getobject.baseDistance;
                } else {
                    longestDistance = this.state.pickupToDelivery.distance;
                }

                this.setState({
                    longestDistance: longestDistance,
                    travelDuration: travelDuration,
                    travelDurationBP : this.state.baseToPickup.timeEstimate,
                    travelDurationDB : this.state.baseToDelivery.timeEstimate,
                    travelDurationPD : this.state.pickupToDelivery.timeEstimate,
                    deliveryState: deliveryState,
                    pickupState: pickupState
                }, () => console.log("longestDistance", longestDistance, ' pickupBaseDistances ', pickupBaseDistances, " travelDuration", travelDuration," travelDurationPD",  this.state.pickupToDelivery.timeEstimate))
            }
        }
    }

    /**
     * Validating all fiedls, saving First Step state to Top state
     * and proceeding to next step
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleNext(event) {

        event.preventDefault();
        console.log('You have selected:', this.state);

        // If all fields are valid calculate distance and proceed to the next step.
        if (
            this.state.movingFromAddress.isValid &&
            this.state.movingToAddress.isValid &&
            this.state.movingFromFlights.value &&
            this.state.movingToFlights.value &&
            this.state.movingFromElevator &&
            this.state.movingToElevator &&
            this.state.movingDate) {

            // Saving current state to top state and going to next step
            const calcFormAnchor = (window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);
            const activeStep = this.readTopState('activeStep');
            this.saveTopState({
                activeStep: activeStep + 1,
                firstStepState: this.state,
            }, () => window.scrollTo(0, calcFormAnchor));

        }
        // If fields are not valid show errors
        else {
            this.setState({ errorclass: 'input-error' });
        }

    };


    /**
     * Inititate autocomplete when the component renders
     * @return {[type]} [description]
     */
    componentDidMount() {
        if (document.getElementById("second-step-change")) {
            if (document.querySelector(".second-step-expand").classList.contains("second-step-expandthis")) {
                document.querySelector(".second-step-expand").classList.remove("second-step-expandthis");
            }
            if (document.querySelector(".second-step-hide").classList.contains("second-step-hidethis")) {
                document.querySelector(".second-step-hide").classList.remove("second-step-hidethis");
            }
        }
        if (document.querySelector(".home_top")) {
            if (document.querySelector(".home_top").classList.contains("second-step-change-bg-pad")) {
                document.querySelector(".home_top").classList.remove("second-step-change-bg-pad");
            }
        }


        /**FRONT END BETWEEN STEPS STYLE**/

        // Get the from/to fields from DOM
        const inputFrom = document.getElementById('movingFromAddress');
        const inputTo = document.getElementById('movingToAddress');

        // Inititate autocomplete on address from
        AddressAutocomplete.initAutocomplete('inputFrom', inputFrom, (autocompleteService) => {

            const place = autocompleteService.getPlace();
            console.log(place);
            const cityAndState = AddressAutocomplete.getCityAndState(place.address_components);

            let searchFromPostalCode = "";
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                console.log(addressType);
                if (addressType === "postal_code") {
                    searchFromPostalCode = place.address_components[i].long_name;
                }
            }
            let streetAddress = "";
            if (place.name) {
                streetAddress = place.name;
            }

            // Save location info to state and calculate distances if both addreses are defined
            this.setState({
                movingFromAddress: {
                    'value': place.geometry.location,
                    'label': place.formatted_address,
                    'isValid': true,
                    'cityAndState': cityAndState,
                    'searchFromPostalCode': searchFromPostalCode,
                    'streetAddress': streetAddress
                }
            }, this.calculateDistances);

            // Set classname to valid
            inputFrom.className = "input-valid";

        });

        // Inititate autocomplete on address to
        AddressAutocomplete.initAutocomplete('inputTo', inputTo, (autocompleteService) => {

            const place = autocompleteService.getPlace();
            const cityAndState = AddressAutocomplete.getCityAndState(place.address_components);

            let searchToPostalCode = "";
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                console.log(addressType);
                if (addressType === "postal_code") {
                    searchToPostalCode = place.address_components[i].long_name;
                }
            }
            let streetAddress = "";
            if (place.name) {
                streetAddress = place.name;
            }

            // Save location info to state and calculate distances if both addreses are defined
            this.setState({
                movingToAddress: {
                    'value': place.geometry.location,
                    'label': place.formatted_address,
                    'isValid': true,
                    'cityAndState': cityAndState,
                    'searchToPostalCode': searchToPostalCode,
                    'streetAddress': streetAddress
                }
            }, this.calculateDistances);

            // this.setState({

            // })

            // Set classname to valid
            inputTo.className = "input-valid";

        });
    }

    render() {

        return (
            <div className="qc-first-step">
    <div className="show-grid">
        <h2 className="md-calc-main-title">Get Your Free Estimate</h2>
        <div className="moving-form-wrapper">
          <div className="md-moving-from">
              <h3 className="md-movingf-title md-move-c-title"><img src="/wp-content/plugins/quote-calculator-r/assets/img/moving-from-to.png" alt="Location Icon"/>Moving From</h3>
              <div className="md-moving-flex">
                  <div className="md-moving-half">
                    <input id="movingFromAddress" type="text" name="movingFromAddress" placeholder="ZIP (choose from suggestion)" defaultValue={this.state.movingFromAddress.label} className={ !this.state.movingFromAddress.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange} />
                  </div>
                  <div className="md-select-wrapper md-moving-half">
                          <select name="movingFromElevator" type="select" defaultValue={this.state.movingFromElevator.value || 0} className={ !this.state.movingFromElevator.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                              <option disabled value="0">Building Type</option>
                              {firstStepConstants.flights.map(option =>
                              <option name="movingFromElevator" key={option.value} value={option.value}>{option.label}</option>
                              )};
                          </select>
                    </div>
                   
                  </div>
                   <div className="md-select-wrapper md-moving-full">
                      <div style={{ display: (this.state.movingFromElevator.label === 'House' || this.state.movingFromElevator.label === 'Townhome')  ? 'block' : 'none' }}>
                          <select name="movingFromFlights" type="select" defaultValue={this.state.movingFromFlights.value || 0} className={ !this.state.movingFromFlights.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                              <option disabled value="0">Select Floor</option>
                              {firstStepConstants.moveSizesHouse.map(option =>
                              <option name="movingFromFlights" key={option.value} value={option.floor}>{option.label}</option>
                              )};
                          </select>
                      </div>
                      <div style={{ display: (this.state.movingFromElevator.label === 'Apartment' || this.state.movingFromElevator.label === 'Condo' || this.state.movingFromElevator.label === 'Storage' || this.state.movingFromElevator.label === 'Commercial')  ? 'block' : 'none' }}>
                          <select name="movingFromFlights" type="select" defaultValue={this.state.movingFromFlights.value || 0} className={ !this.state.movingFromFlights.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                              <option disabled value="0">Select Floor</option>
                              {firstStepConstants.moveSizesApartment.map(option =>
                              <option name="movingFromFlights" key={option.value} value={option.floor}>{option.label}</option>
                              )};
                          </select>
                      </div>
                      <div style={{ display: this.state.movingFromElevator.label === 'High Rise'  ? 'block' : 'none' }}>
                          <select name="movingFromFlights" type="select" defaultValue={this.state.movingFromFlights.value || 0} className={ !this.state.movingFromFlights.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                              <option disabled value="0">Select Floor</option>
                              {firstStepConstants.moveSizesHigh.map(option =>
                              <option name="movingFromFlights" key={option.value} value={option.floor}>{option.label}</option>
                              )};
                          </select>
                      </div>
                      </div>

              </div>
       
          <div className="md-moving-to">
              <h3 className="md-movingt-title md-move-c-title"><img src="/wp-content/plugins/quote-calculator-r/assets/img/moving-from-to.png" alt="Location Icon"/>Moving To</h3>
              <div className="md-moving-flex">
                  <div className="md-moving-third">
                    <input type="text" id="movingToAddress" name="movingToAddress" placeholder="ZIP (choose from suggestion)" defaultValue={this.state.movingToAddress.label} className={ !this.state.movingToAddress.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange} />
                  </div>
                  <div className="md-select-wrapper md-moving-third">
                        <select name="movingToElevator" type="select" defaultValue={this.state.movingToElevator.value || 0} className={ !this.state.movingToElevator.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                            <option disabled value="0">Build Type</option>
                            {firstStepConstants.flights.map(option =>
                            <option name="movingToElevator" key={option.value} value={option.value}>{option.label}</option>
                            )};
                        </select>
                    </div>
                   <div className="md-select-wrapper md-moving-third">
                  <DatePicker id="thedate" placeholderText="Moving date" minDate={moment()} defaultValue={this.state.movingDate || null } selected={ this.state.movingDate ? moment(this.state.movingDate) : null } className={ !this.state.movingDate ? this.state.errorclass : "untouched" } onChange={this.onDateChange} />
                  </div>
                 
              </div>
               <div className="md-select-wrapper md-moving-full">
                      <div style={{ display: (this.state.movingToElevator.label === 'House' || this.state.movingToElevator.label === 'Townhome')  ? 'block' : 'none' }}>
                          <select name="movingToFlights" type="select" defaultValue={this.state.movingToFlights.value || 0} className={ !this.state.movingToFlights.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                              <option disabled value="0">Select Floor</option>
                              {firstStepConstants.moveSizesHouse.map(option =>
                              <option name="movingToFlights" key={option.value} value={option.floor}>{option.label}</option>
                              )};
                          </select>
                      </div>
                      <div style={{ display: (this.state.movingToElevator.label === 'Apartment' || this.state.movingToElevator.label === 'Condo' || this.state.movingToElevator.label === 'Storage' || this.state.movingToElevator.label === 'Commercial')  ? 'block' : 'none' }}>
                          <select name="movingToFlights" type="select" defaultValue={this.state.movingToFlights.value || 0} className={ !this.state.movingToFlights.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                              <option disabled value="0">Select Floor</option>
                              {firstStepConstants.moveSizesApartment.map(option =>
                              <option name="movingToFlights" key={option.value} value={option.floor}>{option.label}</option>
                              )};
                          </select>
                      </div>
                 
                    <div style={{ display: this.state.movingToElevator.label === 'High Rise'  ? 'block' : 'none' }}>
                        <select name="movingToFlights" type="select" defaultValue={this.state.movingToFlights.value || 0} className={ !this.state.movingToFlights.label ? this.state.errorclass : "untouched" } onChange={this.onInputFieldChange}>
                            <option disabled value="0">Select Floor</option>
                            {firstStepConstants.moveSizesHigh.map(option =>
                            <option name="movingToFlights" key={option.value} value={option.floor}>{option.label}</option>
                            )};
                        </select>
                    </div>
                  </div>
          </div>
        </div>
    </div>
    <div className="holder">
        <div className="steps-navigation qc-first-step-nav">
            <Button bsStyle="primary" bsSize="large" type="submit" onClick={this.handleNext}>Get An Estimate</Button>
        </div>
    </div>
</div>
        );
    }
}

export default FirstStep;


// WEBPACK FOOTER //
// ./src/steps/FirstStep.js